export default __webpack_public_path__ + "static/media/IMG_6328.f3e98648.JPG";